// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-2IvCc7E0 fl","box":"box-7EozLU_6"};